<script setup lang="ts">
import { useStrapiWinnersSidebar } from '@nimbus/composables/strapi/useStrapiWinnersSidebar'
import type { components as StrapiComponents } from '@core/types/clients/strapi'
import { computed, ref, useTracking } from '#imports'

const { getWinnersSidebarByKey } = useStrapiWinnersSidebar()

const { trackEvent } = useTracking()

const props = defineProps<{
    winnersSidebarKey: string
    winnersSidebar?: StrapiComponents['schemas']['WinnersSidebar']
}>()

const { data: winnersSidebarSection } = await (props.winnersSidebar
    ? { data: ref(props.winnersSidebar) }
    : getWinnersSidebarByKey({ server: true }, props.winnersSidebarKey))

if (!winnersSidebarSection.value) {
    trackEvent({
        event_name: `missing_winners_sidebar_section`,
        event_type: 'load',
        meta_data: [{ WinnersSidebarKey: props.winnersSidebarKey }],
        log_entry: true
    })
}

const slugs = computed(() => {
    return (winnersSidebarSection.value?.gameTiles?.map(tile => tile.slug).filter((slug): slug is string => typeof slug === 'string') || [])
})
</script>

<template>
    <WinnersSidebar
        v-if="winnersSidebarSection"
        :winners-sidebar-key="props.winnersSidebarKey"
        :horizontal="winnersSidebarSection.horizontal"
        :flipped-order="winnersSidebarSection.flippedOrder"
        :show-jackpot-winner="winnersSidebarSection.showJackpotWinner"
        :winner-list-limit="winnersSidebarSection.winnerListLimit"
        :winner-tile-skeletons="winnersSidebarSection.winnerTileSkeletons"
        :title="winnersSidebarSection.title"
        :shiny-combined-jackpot="winnersSidebarSection.shinyCombinedJackpot"
        :fade-color="winnersSidebarSection.fadeColor"
        :title-color="winnersSidebarSection.titleColor"
        :slugs="slugs"
    />
</template>
